import { render } from "./TheAppHeader.vue?vue&type=template&id=7c3a5126&scoped=true"
import script from "./TheAppHeader.vue?vue&type=script&lang=js"
export * from "./TheAppHeader.vue?vue&type=script&lang=js"

import "./TheAppHeader.vue?vue&type=style&index=0&id=7c3a5126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3a5126"]])

export default __exports__